import React from "react";

const RAG_MAP = {
  green:    { bg: "rgba(0,230,118,0.15)",  color: "#00E676", border: "#00E67644", label: "ON TRACK"  },
  amber:    { bg: "rgba(255,184,0,0.15)",   color: "#FFB800", border: "#FFB80044", label: "AT RISK"   },
  red:      { bg: "rgba(255,61,87,0.15)",   color: "#FF3D57", border: "#FF3D5744", label: "FAILING"   },
  critical: { bg: "rgba(255,0,80,0.2)",     color: "#FF003A", border: "#FF003A55", label: "CRITICAL"  },
  blue:     { bg: "rgba(0,212,255,0.15)",   color: "#00D4FF", border: "#00D4FF44", label: "COMPLETE"  },
  grey:     { bg: "rgba(107,141,176,0.15)", color: "#6B8DB0", border: "#6B8DB044", label: "N/A"       },
};

export default function RAGBadge({ status = "grey", label, size = "sm" }) {
  const s = RAG_MAP[status] || RAG_MAP.grey;
  const displayLabel = label || s.label;
  const padding = size === "lg" ? "4px 14px" : "2px 10px";
  const fontSize = size === "lg" ? "12px" : "10px";

  return (
    <span style={{
      display: "inline-block",
      padding,
      borderRadius: "20px",
      fontSize,
      fontWeight: 700,
      letterSpacing: "0.6px",
      textTransform: "uppercase",
      background: s.bg,
      color: s.color,
      border: `1px solid ${s.border}`,
      whiteSpace: "nowrap",
    }}>{displayLabel}</span>
  );
}

export function ragFromScore(score) {
  if (score >= 80) return "red";
  if (score >= 50) return "amber";
  if (score >= 0)  return "green";
  return "grey";
}

export function ragFromHealth(health) {
  const h = health?.toLowerCase() || "";
  if (h.includes("critical")) return "critical";
  if (h.includes("fail") || h.includes("red")) return "red";
  if (h.includes("risk") || h.includes("amber")) return "amber";
  if (h.includes("track") || h.includes("green")) return "green";
  if (h.includes("complete") || h.includes("blue")) return "blue";
  return "grey";
}
